import classNames from "classnames";
import { useState } from "react";
import { Col, Row } from "react-grid-system";
import { GetAccountResponse } from "../../lib/api/models";
import { useSendTestPushNotification } from "../../lib/api/queries";
import Container from "../../modules/common/Container";
import { ToolType } from "../AccountDetails";
import { toolTypeToName } from "../AccountDetails/utils";
import Subtool from "../common/Subtool";
import StyledButton from "../common/buttons/StyledButton";
import toolStyles from "../../sharedStyles/Tool.module.css";
import styles from "./SendTestPushNotification.module.css";
import { ChannelMapToFull } from "../../lib/channelUtil";
import { useChannelState } from "../../lib/channelContext";

const strings = {
  close: "Close",
  hasSentNotification: "Re-Send Notification",
  hasSentNotificationMessage: "Push Notification Sent!",
  sendNotification: "Send Test Push Notification",
  subheader: (dwbuid: string) => `Test Notify Account ${dwbuid}`,
};

type Props = {
  account: GetAccountResponse;
  onDisplayGeneralErrors: (err: unknown) => void;
  className?: string;
  toolId: string;
  referenceId?: string;
  onRequestClose: () => void;
};

export function SendTestPushNotification({
  account,
  onDisplayGeneralErrors,
  className,
  toolId,
  referenceId = "",
  onRequestClose,
}: Props) {
  const { channel } = useChannelState();

  const [hasSentNotification, setHasSentNotification] = useState(false);
  const { mutateAsync: sendTestPushNotification, isLoading } =
    useSendTestPushNotification();

  const onSubmit = () => {
    sendTestPushNotification({
      partyId: account.partyId,
      referenceId,
      channel: ChannelMapToFull[channel],
    })
      .then(() => setHasSentNotification(true))
      .catch((err) => {
        setHasSentNotification(false);
        onDisplayGeneralErrors(err);
      });
  };

  return (
    <div className={classNames(toolStyles.container, className)} id={toolId}>
      <Container>
        <Row className={toolStyles.header}>
          <Col md={3} className={toolStyles.centerCol}>
            <h2 className={toolStyles.title}>
              {toolTypeToName(ToolType.TestPushNotification)}
            </h2>
          </Col>
          <Col md={1} className={toolStyles.centerCol}>
            <StyledButton
              className={toolStyles.headerButton}
              variant="secondary"
              renderLoadingIndicator={false}
              onClick={onRequestClose}
            >
              {strings.close}
            </StyledButton>
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <Subtool className={styles.container}>
              <span className={styles.subheader}>
                {strings.subheader(account.currentDwbuid)}
              </span>
              {hasSentNotification ? (
                <div className={styles.hasSentNotificationMessage}>
                  {strings.hasSentNotificationMessage}
                </div>
              ) : null}
              <StyledButton
                className={classNames({
                  [styles.button]: true,
                  [styles.buttonAfterSending]: hasSentNotification,
                })}
                onClick={onSubmit}
                isLoading={isLoading}
              >
                {hasSentNotification
                  ? strings.hasSentNotification
                  : strings.sendNotification}
              </StyledButton>
            </Subtool>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
